import {Dto, DtoWithId} from "@mango/core";


@Dto({fullName: "AccessMonitor.Logic.School"})
export class School extends DtoWithId {
  id: number;
  name: string;
}
